import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ExperienceRibbon } from '../components/ExperienceRibbon';
import { CulinaryGrid } from '../components/CulinaryGrid';
import { StorySection } from '../components/StorySection';
import { SocialTicker } from '../components/SocialTicker';
interface HomeProps {
  onNavigate: (page: string) => void;
}
export function Home({
  onNavigate
}: HomeProps) {
  return <main data-id="element-289">
      <HeroSection data-id="element-290" />
      <ExperienceRibbon onNavigate={onNavigate} data-id="element-291" />
      <CulinaryGrid data-id="element-292" />
      <StorySection data-id="element-293" />
      <SocialTicker data-id="element-294" />
    </main>;
}